import React, { useEffect, useRef, useCallback } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getZendeskLinkAndToken } from 'src/hooks/zendesk/api/getZendeskUrl'
import { useLoginStatus } from 'src/hooks/useLoginStatus'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { useTranslation } from 'react-i18next'
import { CheqLoader } from '@clickcease/cc-client-components-lib'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const HelpCenterLinking = () => {
  const { t } = useTranslation('general')
  const { isLoggedIn } = useLoginStatus()
  const navigate = useNavigate()
  const { showToaster } = useAppStore()
  const [searchParams] = useSearchParams()
  const hcArticle = searchParams.get('hc')

  const article = hcArticle ? hcArticle.replace(/['"“”\s]+/g, '') : ''

  const { userId } = useUserStore()

  const formRef = useRef<HTMLFormElement>(null)
  const jwtInputRef = useRef<HTMLInputElement>(null)
  const returnToInputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (!isLoggedIn) {
      showToaster(t('redirect.login_to_view_help_center'), 'info')
      navigate('/login', {
        state: { redirect: 'help-center-link', searchParams: { hc: article } },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  const handleClick = useCallback(() => {
    getZendeskLinkAndToken(userId)
      .then((response) => {
        if (!(response instanceof Error) && response?.data) {
          if (jwtInputRef?.current && formRef) {
            jwtInputRef.current.value = response.data.jwt
          }

          if (returnToInputRef?.current && formRef) {
            const url = new URL(response.data.return_to)
            if (hcArticle) url.pathname = url.pathname + '/' + hcArticle.replace(/^\//, '')
            returnToInputRef.current.value = url.toString()
          }

          if (formRef.current) {
            formRef.current.action = response.data.jwt_req_url
            formRef.current.submit()
          }
        }
      })
      .catch((err: Error) => console.error(err))
  }, [hcArticle, userId])

  useEffect(() => {
    if (!isNaN(userId)) handleClick()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  return (
    <>
      <CheqLoader />
      <form ref={formRef} method="post" style={{ display: 'none' }}>
        <input ref={jwtInputRef} type="hidden" name="jwt"></input>
        <input ref={returnToInputRef} type="hidden" name="return_to"></input>
      </form>
    </>
  )
}
